import type { FC } from 'react';
import { useEffect } from 'react';
import { toast } from 'sonner';
import type { OfferDetailsResponse } from 'src/apis/super-bundle-service/types';
import { useSuperBundleOfferDelete } from 'src/apis/super-bundle-service/use-super-bundle-offer-delete';
import { Modal } from 'src/components/overlay/modal';
import { Forbidden } from 'src/utils/errors';

type Props = {
  close: () => void;
  onSuccess: () => void;
  offer: OfferDetailsResponse;
};

export const DeleteOfferModal: FC<Props> = ({ close, onSuccess, offer }) => {
  const deleteLink = offer._links.deleteOffer;
  if (!deleteLink) throw new Forbidden();

  const offerDelete = useSuperBundleOfferDelete();

  useEffect(() => {
    if (!offerDelete.response) return;
    toast.success('Offer was successfully deleted.');
    close();
    onSuccess();
    // oxlint-disable-next-line exhaustive-deps
  }, [offerDelete.response]);

  return (
    <Modal
      data-testid="delete-offer-modal"
      title="Delete Offer"
      onDismiss={close}
      footer={{
        confirmButton: {
          label: offerDelete.pending ? 'Pending...' : 'Delete Offer',
          onClick: () => offerDelete.execute(deleteLink.href),
          disabled: offerDelete.pending,
          dataTestId: 'confirm-delete-offer',
        },
      }}
    >
      <p>Please, confirm that you want to delete {offer.name}.</p>
    </Modal>
  );
};
